import { Query } from "@tanstack/react-query";

export type Booking = { id: number } & Record<string, unknown>;

export const bookingKeys = {
  all: () => ["bookings"],
  list: (params?: unknown) => [
    ...bookingKeys.all(),
    "list",
    ...(((params && (Array.isArray(params) ? params : [params])) as Array<unknown>) || [])
  ],
  single: (bookingId?: number, profileId?: number) => [
    ...bookingKeys.all(),
    bookingId,
    ...(profileId ? [profileId] : [])
  ],
  isBookingQuery: (query: Query) => query.queryKey[0] === "bookings"
};

export const bookingTemplateKeys = {
  all: () => ["booking_templates"],
  list: (params?: unknown) => [
    ...bookingTemplateKeys.all(),
    "list",
    ...(((params && (Array.isArray(params) ? params : [params])) as Array<unknown>) || [])
  ],
  single: (id: number | undefined) => [...bookingTemplateKeys.all(), id?.toString()]
};
